import type { Ref } from 'react'
import { GoogleIcon } from '@/src/renderer/components/icons/GoogleIcon'
import { AppleIcon } from '@/src/renderer/components/icons/AppleIcon'
import type { SocialButtonProps } from './SocialButton.types'
import './SocialButton.scss'

export function SocialButton({
  provider,
  onClick,
  children,
  className,
  ref,
  ...rest
}: SocialButtonProps & { ref?: Ref<HTMLButtonElement> }) {
  const Icon = provider === 'google' ? GoogleIcon : AppleIcon

  return (
    <button
      {...rest}
      ref={ref}
      onClick={onClick}
      className={`social-button${className ? ` ${className}` : ''}`}
    >
      <Icon />
      <span className="social-button__text">{children}</span>
    </button>
  )
}
